
// TextBox.js
import React from 'react';
import DOMPurify from 'dompurify';

const TextBox = ({ textBoxHeadline = '', textBoxBody = ''}) => (
	<div className="l-grid l-grid--max-width c-component-header u-margin-top-xl u-margin-bottom-m">
		<div className="l-grid__row">
			<div className="l-grid__column-medium-10 offset-medium-1 c-component-header__headline-wrapper">
			{textBoxHeadline && (
				<div className="c-heading--section__container js-enable-infopoints c-headline__item">
					<h3 className="c-heading  c-heading--section u-text-center c-component-header__headline c-link--capitalize "
						dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(textBoxHeadline) }}>
					</h3>
				</div>
			)}
			</div>
			<div className="offset-large-1 offset-medium-1 l-grid__column-large-10 l-grid__column-medium-10">
				<div className="c-copy c-component-header__copytext  "
					dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(textBoxBody) }}>
				</div>
			</div>
		</div>
	</div>
);

export default TextBox;
